import React, { useState, useEffect } from 'react';
import {
    Box,
    Center,
    Heading,
    HStack,
    Image,
    Link,
    Text,
} from "native-base";

const image = require('../../assets/icon.png');

const Subscribe = (props) => {
    return (
        <Center
            // position="fixed"
            // top="90"
            // zIndex="99999"
            bg="primary.300"
            w="100%"
            p="6"
            m="2"
            {...props}
        >
            <Box
                maxW="400"
                width="80%">
                <Heading
                    size="sm"
                    mb="2"
                    textAlign="center">
                    Subcribe to get updates!
                </Heading>
                <iframe
                    src="https://embeds.beehiiv.com/b41c12f6-10c4-4e00-9c7b-761dcc053ad6?slim=true"
                    data-test-id="beehiiv-embed"
                    width="100%"
                    height="55"
                    frameBorder="0"
                    scrolling="no"
                    style={{
                        zIndex: 99999,
                        borderRadius: '4px',
                        //border: '2px solid #e5e7eb',
                        margin: 0,
                        backgroundColor: 'transparent'
                    }}></iframe>
            </Box>
        </Center>
    );
}

export default Subscribe;